import { render, staticRenderFns } from "./ListConfigDatasetField.vue?vue&type=template&id=46a2ca08"
import script from "./ListConfigDatasetField.vue?vue&type=script&lang=js"
export * from "./ListConfigDatasetField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports